/**
 * Translation Context.
 *
 * @format *
 */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { createContext, useEffect, useState } from 'react';
import { safeLanguageUrlPrefix } from '@services/drupal-services';

/**
 * Translation Context.
 */
export const TranslationContext = createContext();

/**
 * Translation Provider.
 *
 * @param {object} props
 */
export const TranslationProvider = (props): JSX.Element => {
  const [translationBlob, setTranslationBlob] = useState(null);
  const { children } = props;

  /**
   * Imports Translation Object.
   */
  const getTranslationBlob = async () => {
    let prefix = safeLanguageUrlPrefix().replace('/', '');
    const translatedLanguages: string[] = [
      'de',
      'en-au',
      'en-gb',
      'es-419',
      'es-xl',
      'es',
      'fr',
      'ja',
      'pt-br',
      'pt-pt',
      'zh-hans',
      'zh-hant',
      'fr-ca',
    ];

    if (prefix === 'es-xl') {
      prefix = 'es-419';
    }

    if (prefix && translatedLanguages.includes(prefix)) {
      const { default: result } = await import(
        `../../../build/json/varian.${prefix}.json`
      );
      setTranslationBlob(result);
    }
  };

  useEffect(() => {
    getTranslationBlob();
  }, []);

  /**
   * Render.
   */
  return (
    <TranslationContext.Provider value={translationBlob}>
      {children}
    </TranslationContext.Provider>
  );
};
